// removed by extract-text-webpack-plugin
module.exports = {"Container":"Suggestions__Container___uWGXj","SectionCarousel":"Suggestions__SectionCarousel___2Kz_A","SectionCarouselTitle":"Suggestions__SectionCarouselTitle___3eiXS","Carousel":"Suggestions__Carousel___1OIwY","CarouselArrows":"Suggestions__CarouselArrows___1wodV","CarouselArrow":"Suggestions__CarouselArrow___3XuUI","Prev":"Suggestions__Prev___2yBxt","Next":"Suggestions__Next___Hqm1v","Disabled":"Suggestions__Disabled___1n_FF","Slides":"Suggestions__Slides___2Lt4z","Item":"Suggestions__Item___3b33Z","ObjectCardEmpty":"Suggestions__ObjectCardEmpty___3NKes"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Main/Suggestions/Suggestions.scss
// module id = 1373
// module chunks = 0